(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["myortica-campaign-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('db-november-bar')) {
    customElements.define(
      'db-november-bar',
      class extends HTMLElement {
        connectedCallback() {
          if (this.started) return;

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.started = true;
            return;
          }

          if (!('IntersectionObserver' in window)) {
            this.start();
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                this.observer.disconnect();
                this.start();
              }
            },
            { threshold: 0.4 }
          );

          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) {
            this.observer.disconnect();
          }

          if (this.runningAnimations) {
            this.runningAnimations.forEach((animation) => {
              animation.cancel();
            });
          }
        }

        start() {
          if (this.started) return;
          this.started = true;

          const numberElement = this.querySelector('.db-november__number');
          const discount = Number(this.dataset.discount);

          if (!numberElement) return;
          if (!Number.isInteger(discount)) return;
          if (discount < 1 || discount > 99) return;

          this.classList.add('is-active');

          if (typeof numberElement.animate !== 'function') return;

          const fragment = document.createDocumentFragment();
          const tracks = [];
          const digits = String(discount).split('');

          digits.forEach((character, index) => {
            const target = Number(character);
            const sequence = [];

            if (index === 0) {
              for (let value = 0; value <= 9; value++) {
                sequence.push(value);
              }

              for (let value = 0; value <= target; value++) {
                sequence.push(value);
              }
            } else {
              for (let value = 9; value >= 0; value--) {
                sequence.push(value);
              }

              for (let value = 9; value >= target; value--) {
                sequence.push(value);
              }
            }

            const digit = document.createElement('span');
            digit.className = 'db-november__digit';

            const track = document.createElement('span');
            track.className = 'db-november__track';

            sequence.reverse().forEach((value) => {
              const step = document.createElement('span');
              step.className = 'db-november__step';
              step.textContent = String(value);
              track.appendChild(step);
            });

            digit.appendChild(track);
            fragment.appendChild(digit);

            tracks.push({
              element: track,
              steps: sequence.length
            });
          });

          numberElement.replaceChildren(fragment);
          this.runningAnimations = [];

          tracks.forEach((item, index) => {
            const track = item.element;
            const startPosition = -(item.steps - 1);

            const animation = track.animate(
              [
                {
                  transform: 'translateY(' + startPosition + 'em)'
                },
                {
                  transform: 'translateY(0)'
                }
              ],
              {
                duration: 1700 + index * 250,
                delay: 350 + index * 100,
                easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
                fill: 'both'
              }
            );

            animation.onfinish = () => {
              track.style.transform = 'translateY(0)';
              animation.cancel();
            };

            this.runningAnimations.push(animation);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
